export default "__VITE_ASSET__BpjLx6SG__"